import { Permission, useAbility } from "../logic/rbac";
import AccessDenied from "./AccessDenied";

export interface CanProps { 
  perform: Permission; 
  children: React.ReactNode;
  variant?: 'hide' | 'show_message';
  access_denied_title?: string;
  access_denied_message?: string
}

export const Can = ({ 
  perform, 
  children,
  variant = 'show_message',
  access_denied_title,
  access_denied_message
}: CanProps) => {
  const { can } = useAbility();

  if (can(perform)) {
    return <>{children}</>;
  }

  if(variant==="hide")
    return null;

  return <AccessDenied title={access_denied_title} message={access_denied_message}/>
};